<template>
  <el-dialog
      v-el-drag-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :title="scrapRegistration.id > 0 ? '编辑' : '新建'"
      width="1000px"
      top="5vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        :model="scrapRegistration"
        label-width="120px">
      <el-form-item v-if="scrapRegistration.id > 0" prop="billNo" label="单据编号">
        <span>{{scrapRegistration.billNo}}</span>
      </el-form-item>
      <div class="vm-separate">
        <el-form-item prop="repairRegistrationNo" label="维修登记编号" :rules="$rule.notNull">
          <el-input v-model="scrapRegistration.repairRegistrationNo" placeholder="请选择维修登记编号" @change="repairRegistrationsNoChange">
            <el-button slot="append" icon="el-icon-search" @click="$refs.repairRegistrationSelect.open()"/>
          </el-input>
        </el-form-item>
        <el-form-item prop="afterSaleType" label="维修类型" :rules="$rule.notNull">
          <el-select v-model="scrapRegistration.afterSaleType" placeholder="请选择维修类型">
            <el-option value="更换"/>
            <el-option value="维修"/>
            <el-option value="回采"/>
            <el-option value="批量整改"/>
          </el-select>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item prop="afterSaleOrderNo" label="售后单号" :rules="$rule.notNull">
          <el-input v-model.trim="scrapRegistration.afterSaleOrderNo" placeholder="请输入售后单号"/>
        </el-form-item>
        <el-form-item prop="qualityRegistrationNo" label="质量异常单号" :rules="$rule.notNull">
<!--          <el-input v-model="scrapRegistration.qualityRegistrationNo" placeholder="请选择质量异常单号">-->
<!--            <el-button slot="append" icon="el-icon-search" @click="$refs.qualityRegSelect.open()"/>-->
<!--          </el-input>-->
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item prop="salesOrderNo" label="销售订单号">
          <el-input v-model="scrapRegistration.salesOrderNo" readonly placeholder="请选择销售订单号">
            <el-button slot="append" icon="el-icon-search" @click="$refs.salesOrderSelect.open()"/>
          </el-input>
        </el-form-item>
        <el-form-item prop="department" label="事业部" :rules="$rule.notNull">
          <el-select v-model="scrapRegistration.department" placeholder="请选择事业部">
            <el-option value="电气"/>
            <el-option value="电机"/>
            <el-option value="运控"/>
            <el-option value="机器人"/>
            <el-option value="杭州之山"/>
            <el-option value="其他"/>
          </el-select>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item prop="demandNode" label="需求节点" :rules="$rule.notNull">
          <el-select v-model="scrapRegistration.demandNode" placeholder="请选择需求节点">
            <el-option value="售后"/>
            <el-option value="生产"/>
            <el-option value="拆解部件"/>
            <el-option value="OEM厂内组装"/>
            <el-option value="OEM厂内负载"/>
            <el-option value="OEM厂内包装"/>
            <el-option value="OEM厂内物流"/>
            <el-option value="OEM厂内SMT"/>
            <el-option value="外协工厂"/>
            <el-option value="研发"/>
          </el-select>
        </el-form-item>
        <el-form-item prop="partType" label="部件类型" :rules="$rule.notNull">
          <el-select v-model="scrapRegistration.partType" placeholder="请选择部件类型">
            <el-option value="整机"/>
            <el-option value="板卡"/>
            <el-option value="抱闸电源"/>
            <el-option value="操作器"/>
            <el-option value="IGBT模块"/>
            <el-option value="电容"/>
            <el-option value="电流传感器"/>
            <el-option value="线束"/>
            <el-option value="电子元件"/>
            <el-option value="其它器件"/>
            <el-option value="其它"/>
          </el-select>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item prop="serialNo" label="序列号" :rules="$rule.notNull">
          <el-input v-model.trim="scrapRegistration.serialNo" placeholder="请输入序列号" @change="serialNoChange"/>
        </el-form-item>
        <el-form-item prop="materialNo" label="物料号" :rules="$rule.notNull">
          <el-input v-model="scrapRegistration.materialNo" placeholder="请选择物料" readonly>
            <el-button v-if="!scrapRegistration.salesOrderNo || scrapRegistration.salesOrderNo === '*'" slot="append" icon="el-icon-search" @click="$refs.materialSelect.open()"/>
          </el-input>
        </el-form-item>
      </div>
      <el-form-item prop="materialName" label="物料描述">
        <el-input v-model="scrapRegistration.materialName" :disabled="!scrapRegistration.materialNo" readonly/>
      </el-form-item>
      <div class="vm-separate">
        <el-form-item prop="quantity" label="报废数量" :rules="$rule.notNull">
          <el-input v-model.number="scrapRegistration.quantity" type="number" min="0" placeholder="请输入报废数量"/>
        </el-form-item>
        <el-form-item prop="scrapType" label="报废类型" :rules="$rule.notNull">
          <el-select v-model="scrapRegistration.scrapType" placeholder="请选择报废类型">
            <el-option value="深入检测后无法修复"/>
            <el-option value="版本过低不再使用"/>
            <el-option value="直观判断无法修复"/>
            <el-option value="拆解利用"/>
          </el-select>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item prop="scrapReason" label="报废原因" :rules="$rule.notNull">
          <el-select v-model="scrapRegistration.scrapReason" placeholder="请选择报废原因">
            <el-option value="检测后无维修价值"/>
            <el-option value="检测后无维修价值报废拆解"/>
            <el-option value="检测IGBT损坏无维修价值(高价值）"/>
            <el-option value="检测后无维修价值拆解IGBT(高价值）"/>
            <el-option value="检测后无法查明原因修复"/>
            <el-option value="直观判断-版本过低不再使用"/>
            <el-option value="直观判断无法修复-线路烧坏"/>
            <el-option value="直观判断无法修复-氧化腐蚀"/>
            <el-option value="直观判断无法修复-外观破损"/>
            <el-option value="直观判断无法修复-污损严重"/>
          </el-select>
        </el-form-item>
        <el-form-item prop="warehouseLocation" label="报废库位" :rules="$rule.notNull">
          <el-select v-model="scrapRegistration.warehouseLocation" placeholder="报废库位">
            <el-option value="2201"/>
            <el-option value="2205"/>
            <el-option value="无库位"/>
          </el-select>
        </el-form-item>
      </div>
      <el-form-item prop="note" label="备注">
        <el-input
            v-model.trim="scrapRegistration.note"
            type="textarea"
            autosize
            placeholder="请输入备注"
            maxlength="500"
            show-word-limit/>
      </el-form-item>
      <template v-if="scrapRegistration.repairOriginParts && scrapRegistration.repairOriginParts.length > 0">
        <el-table
            :data="scrapRegistration.repairOriginParts"
            border
            style="width: 97%; margin-left: 3%">
          <el-table-column
              type="index"
              align="center"
              label="序号"
              width="50px"/>
          <el-table-column
              prop="originPartSn"
              align="center"
              label="原部件条码"
              width="150px"/>
          <el-table-column
              prop="originPartMaterialNo"
              align="center"
              label="原部件物料号"
              width="100px"/>
          <el-table-column
              prop="originPartMaterialName"
              label="原部件物料描述"
              width="250px"
              show-overflow-tooltip/>
          <el-table-column
              prop="originPartQuantity"
              align="center"
              label="原部件数量"
              width="70px"/>
          <el-table-column
              prop="cost"
              align="center"
              label="部件费"
              width="70px"/>
          <el-table-column
              prop="originPartInfo"
              align="center"
              label="部件信息">
            <template v-slot="scope">
              <el-input
                  v-model.trim="scope.row.originPartInfo"
                  style="width: 100%"
                  clearable/>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-form>
    <div style="color: red; font-size: 13px; margin-left: 55px; margin-top: 5px">填表说明：为空的必填项请输入*号</div>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确定</el-button>
    </div>
    <material-select ref="materialSelect" @select="materialSelect"/>
    <repair-registration-select ref="repairRegistrationSelect" @select="repairRegistrationSelect"/>
<!--    <quality-reg-select ref="qualityRegSelect" @select="qualityRegSelect"/>-->
<!--    <sale-order-select ref="salesOrderSelect" @select="salesOrderSelect"/>-->
  </el-dialog>
</template>

<script>
  import RepairRegistrationSelect from "@/views/maintenanceManage/RepairRegistration/RepairRegistrationSelect.vue";
  import MaterialSelect from "@/views/information/SupplierManage/MaterialSelect";
  // import QualityRegSelect from "@/views/Quality/QualityRegTable/QualityRegSelect.vue";
  // import SaleOrderSelect from "@/views/SalesManage/SalesOrder/SaleOrderSelect.vue";

  export default {
    name: "ScrapRegistrationEdit",
    components: {MaterialSelect, RepairRegistrationSelect},
    data() {
      return {
        dialogVisible: false,
        scrapRegistration: {
          id: 0,
          billNo: "",
          repairRegistrationNo: "",
          afterSaleType: "",
          afterSaleOrderNo: "",
          qualityRegistrationNo: "",
          salesOrderNo: "",
          department: "",
          demandNode: "",
          partType: "",
          serialNo: "",
          materialNo: "",
          materialName: "",
          quantity: 1,
          scrapType: "",
          scrapReason: "",
          warehouseLocation: "",
          note: "",
          repairOriginParts: [],
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.id = row.id;
          this.getData();
        }
      },
      getData() {
        this.$http.get("basic", `scrapRegistrations/${this.id}`).then(res => {
          this.scrapRegistration = res;
        });
      },
      materialSelect(row) {
        this.scrapRegistration.materialNo = row.no;
        this.scrapRegistration.materialName = row.name;
      },
      repairRegistrationSelect(row) {
        this.scrapRegistration.repairRegistrationNo = row.billNo;
        this.scrapRegistration.afterSaleType = row.afterSaleType;
        this.scrapRegistration.afterSaleOrderNo = row.afterSaleOrderNo;
        this.scrapRegistration.qualityRegistrationNo = row.qualityRegistrationNo;
        this.scrapRegistration.department = row.department;
        this.scrapRegistration.demandNode = row.demandNode;
        this.scrapRegistration.partType = row.partType;
        this.getRepairOriginPart(row.id);
      },
      qualityRegSelect(row) {
        this.scrapRegistration.qualityRegistrationNo = row.billNo;
      },
      salesOrderSelect(index, row) {
        this.scrapRegistration.salesOrderNo = row.billNo + "/" + row.rowIndex;
        this.scrapRegistration.materialNo = row.materialNO;
        this.scrapRegistration.materialName = row.materialName;
      },
      serialNoChange() {
        if (!this.scrapRegistration.salesOrderNo || this.scrapRegistration.salesOrderNo === "*") {
          if (this.scrapRegistration.serialNo.length > 0) {
            this.$http
              .get("basic", "snSerialNos/getBySn?sn=" + this.scrapRegistration.serialNo)
              .then(res => {
                this.scrapRegistration.materialNo = res.materialNo;
                this.scrapRegistration.materialName = res.materialDescription;
              }).catch(() => {
                this.scrapRegistration.materialNo = "";
                this.scrapRegistration.materialName = "";
              });
          } else {
            this.scrapRegistration.materialNo = "";
            this.scrapRegistration.materialName = "";
          }
        }
      },
      repairRegistrationsNoChange() {
        if (this.scrapRegistration.repairRegistrationNo.startsWith("RR") && this.scrapRegistration.repairRegistrationNo.length === 8) {
          let param = {
            billNo: this.scrapRegistration.repairRegistrationNo,
          };
          this.$http.get("basic", "repairRegistrations/no", param)
            .then(res => {
              this.scrapRegistration.afterSaleType = res.afterSaleType;
              this.scrapRegistration.afterSaleOrderNo = res.afterSaleOrderNo;
              this.scrapRegistration.qualityRegistrationNo = res.qualityRegistrationNo;
              this.scrapRegistration.department = res.department;
              this.scrapRegistration.demandNode = res.demandNode;
              this.scrapRegistration.partType = res.partType;
            }).catch(() => {
              this.scrapRegistration.afterSaleType = "";
              this.scrapRegistration.afterSaleOrderNo = "";
              this.scrapRegistration.qualityRegistrationNo = "";
              this.scrapRegistration.department = "";
              this.scrapRegistration.demandNode = "";
              this.scrapRegistration.partType = "";
            });
        }
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.$http.save("basic", "scrapRegistrations", this.scrapRegistration).then(() => {
              this.$message.success("保存成功");
              this.$emit("save-success");
              this.dialogVisible = false;
            }).catch(() => {
              this.$message.error("保存失败");
            });
          }
        });
      },
      getRepairOriginPart(id) {
        this.$http
          .get("basic", `repairRegistrations/${id}`)
          .then(res => {
            this.scrapRegistration.repairOriginParts = res.originPartList;
          });
      },
    },
  };
</script>

<style scoped lang="scss">
.title {
  border-bottom: 1px solid #ddd;
  margin-bottom: 5px;
  padding-bottom: 5px;
  color: #000;
  font-size: 14px;
  font-weight: 700;
}
</style>
